
<mat-dialog-content>

<div *ngIf="!showList" class="flex flex-col items-center w-full scrollable-div">
  <div class="flex flex-col rounded-lg w-11/12" style="padding: 20px; overflow-x:auto;">
    <span>
      Administrative Edit Complaint
    </span>
    <hr style="border: 1px solid gray;">
    <br />
    <form [formGroup]="businessForm">
      <div class="flex flex-col rounded-lg w-full">

        <div>
          <mat-form-field>
            <mat-label>Business Name</mat-label>
            <input matInput formControlName="businessName" placeholder="Enter business name here">
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-label>Business Type</mat-label>
            <mat-select formControlName="businessType">
              <mat-option *ngFor="let list of businessList" [value]="list.value">
                {{list.text}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div>
          <mat-checkbox class="container" formControlName="active">
            <span>Active</span>
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox class="container" formControlName="exempt" (change)="exemptChange($event)">
            <span>Exempt</span>
          </mat-checkbox>
        </div>

        <div *ngIf="exemptList" class="flex flex-col rounded-lg w-full">
          <hr style="border: 1px solid gray;">

          <span style="color: grey;">
            Additional Exemption Information required:
          </span>
          <div>
            <mat-form-field>
              <mat-label>Exempt Certification Date</mat-label>
              <input matInput [matDatepicker]="exemptCertificateDate" formControlName="exemptCertificateDate">
              <mat-datepicker-toggle matSuffix [for]="exemptCertificateDate"></mat-datepicker-toggle>
              <mat-datepicker #exemptCertificateDate></mat-datepicker>
              <mat-error *ngIf="businessForm.get('exemptCertificateDate').invalid">
                Invalid Date.
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Exempt Status</mat-label>
              <mat-select formControlName="exemptStatusId">
                <mat-option *ngFor="let list of getExemptStatusOptionsList" [value]="list.value">
                  {{list.text}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Exempt Type</mat-label>
              <mat-select formControlName="exemptTypeId">
                <mat-option *ngFor="let list of getExemptTypeOptionsList" [value]="list.value">
                  {{list.text}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div>
            <mat-checkbox class="container" formControlName="exemptSmokingAllowed">
              <span>Cigarette Smoking Allowed</span>
            </mat-checkbox>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Approved By</mat-label>
              <input matInput formControlName="exemptApprovedBy" placeholder="Approved By">
            </mat-form-field>
          </div>

          <hr style="border: 1px solid gray;">

        </div>

        <div>
          <mat-form-field>
            <mat-label>Address 1</mat-label>
            <input matInput formControlName="businessAddress1" placeholder="Enter Address">
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-label>Address 2</mat-label>
            <input matInput formControlName="businessAddress2" placeholder="Enter Address 2">
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-label>City</mat-label>
            <input matInput formControlName="businessCity" placeholder="Enter City">
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-label>Zip</mat-label>
            <input matInput formControlName="businessZip" placeholder="Enter Zip Code">
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-label>Zip Extension</mat-label>
            <input matInput formControlName="businessZipExt" placeholder="Enter Zip Code Extension">
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-label>County</mat-label>
            <mat-select formControlName="countyId">
              <mat-option *ngFor="let list of countyList" [value]="list.value">
                {{list.text}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex flex-row" style="align-items: flex-start;">
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="save()" class="m-8 container" style="background: #7ABDF3;">
              Save
            </button>
          </div>
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="return()" class="m-8 container">
              Return
            </button>
          </div>
        </div>

      </div>

    </form>

  </div>
  <br />
  <hr style="border: 1px solid gray;">
</div>

</mat-dialog-content>